import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.071 10.108c0 2.15-1.918 3.892-4.285 3.892S3.5 12.258 3.5 10.108 6.357 3.622 7.786 2c1.428 1.622 4.285 5.959 4.285 8.108"
    }, null, -1)
  ]))]))
}
export default { render: render }